import { Container, Text } from '@prismeet/react'
import { Outlet } from 'react-router'

import { APP_NAME } from '@/constants'

import { FeaturePush } from './FeaturePush'
import styles from './index.module.scss'

/**
 * Оболочка экранов входа и регистрации.
 *
 * Форма стоит по центру спектрального полотна, а тезисы о продукте приезжают
 * пушами поверх фона: стеклянная карточка должна стоять на цвете, иначе
 * `glassLevel={3}` не отличается от обычной панели, и весь язык системы
 * пропадает ровно на том экране, где его видят все.
 */
export function AuthLayout() {
  return (
    <div className={styles.root}>
      <div className={styles.canvas} aria-hidden="true">
        <span className={`${styles.blob} ${styles.blobBeam}`} />
        <span className={`${styles.blob} ${styles.blobInfo}`} />
        <span className={`${styles.blob} ${styles.blobSuccess}`} />
      </div>

      <FeaturePush />

      <main className={styles.form}>
        {/* Не заголовок: `h1` на экране принадлежит форме, второго быть не должно. */}
        <Text
          variant="title"
          weight="bold"
          className={styles.wordmark}
          style={{ fontFamily: 'var(--ds-font-family-display)' }}
        >
          {APP_NAME}
        </Text>

        <Container
          surface="glass"
          glassLevel={3}
          radius="3xl"
          padding={6}
          safeArea
          className={styles.card}
        >
          <Outlet />
        </Container>
      </main>
    </div>
  )
}
